import firebase from "firebase";

const config = {
  apiKey: "AIzaSyDdJJgRM0p-UH_xTdPD83EBQl8_MhtKmc0",
  authDomain: "arowe-portfolio.firebaseapp.com",
  databaseURL: "https://arowe-portfolio.firebaseio.com/",
  projectId: "arowe-portfolio",
  storageBucket: "arowe-portfolio.appspot.com",
  messagingSenderId: "275989144708"
};
firebase.initializeApp(config);
export const functions = firebase.functions();
export const storages = firebase.storage();